module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d5fe977d97eca9bf23686f4a320fa29f.png";